/**
 * 호출자 → downstream API 요청 및 응답 에코에 사용하는 요청 id 헤더
 * @description
 * - hosts/guard의 SERVER_TRACE_HEADERS.RESPONSE_REQUEST_ID와 값이 동일
 *   Edge runtime 번들 제약으로 그쪽은 @kc-console/core를 import하지 않고 리터럴을 유지
 */
export const KC_REQUEST_ID_HEADER = 'x-kc-request-id';
